import nanoajax from "nanoajax";
import slugify from "slugify";
import Swiper from "swiper";
import Trends from "../../components/seo/Trends";
import { destiny } from "../../shared/destinyTexts";
import { fallbackBestPrices } from "../../shared/fallbackBestPrices";
import { BFF_API, NEARBY_PLACES_API } from "../../shared/constants";
import { airports } from "../../shared/airports";
import { stretchFrom } from "../../searchform";
import { formatCurrency, shuffleArray } from "../../shared/utils";

const state = {
	fetchingResourceFrom: null
};

if (typeof generateStylesheet === "function") {
	generateStylesheet("home");
}

const homePageTestimonials = document.querySelector("#swipers-container");
const newsletterInput = document.getElementById("newsletter-email");
const formNewsletter = document.getElementById("formNewsletter");

System.import("../partials/HomeSwipers").then(module => {
	module.initSwiperAbout();
});

if (formNewsletter) {
	formNewsletter.onsubmit = event => {
		event.preventDefault();
		const successWrapper = document.querySelector(".validate-success-msg");
		const validateError = document.querySelector(".validate-error-msg").parentElement;

		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		const paintError = errorName => {
			validateError.className = "col-xs-16 no-padding";
			validateError.innerHTML = `
                        <div class="alert alert-danger validate-error-msg">
                            <div class="alert--icon">
                                <i class="icon-close"></i>
                            </div>
                            <div class="alert--message">
                                <p>${errorName}</p>
                            </div>
                        </div>`;
		};

		successWrapper.className = successWrapper.className + " hidden";
		validateError.className = validateError.className + " hidden";

		if (re.test(newsletterInput.value.toLowerCase())) {
			extractValues(formNewsletter.querySelectorAll("input, button")).map(item => {
				if (typeof item == "object") item.disabled = true;
			});

			nanoajax.ajax(
				{
					url: "/cadastro-email-marketing",
					method: "POST",
					body: JSON.stringify({ email: newsletterInput.value })
				},
				function(code, responseText, request) {
					console.log(arguments);
					extractValues(formNewsletter.querySelectorAll("input, button")).map(item => {
						if (typeof item == "object") item.disabled = false;
					});

					PubSub.publish("dataLayer", {
						event: "ditoIdentifyEmail",
						ditoIdentify: {
							email: newsletterInput.value
						}
					});

					let cryptoEmail = md5(newsletterInput.value);

					newsletterInput.value = "";

					console.log("code: ", code, code === 400);

					if (code === 201) {
						successWrapper.className = "alert alert-success validate-success-msg";

						PubSub.publish("dataLayer", {
							event: "gaEvent",
							userId: cryptoEmail,
							gaEventCategory: "Identificação de e-mail",
							gaEventAction: "Newsletter",
							gaEventLabel: "home",
							gaEventValue: ""
						});
					}

					if (code === 400) {
						paintError(JSON.parse(responseText)[0].message);
					}

					if (code === 409) {
						paintError("Este email já está cadastrado");
					}

					if (code === 500) {
						paintError("Não foi possível enviar");
					}
				}
			);
		} else {
			paintError("Digite um email válido");
		}
	};
}

export const createComponentsPassagemAerea = () => {
	if (document.body.className.match(".passagem-aerea")) {
		const urlBuscaPassagens = BFF_API;

		const geoLocatedAirports = [];
		const aeroportosmaisbuscados = [
			{ iata: "SAO" },
			{ iata: "FOR" },
			{ iata: "SSA" },
			{ iata: "RIO" },
			{ iata: "REC" },
			{ iata: "CWB" },
			{ iata: "NAT" },
			{ iata: "BSB" },
			{ iata: "BPS" },
			{ iata: "POA" },
			{ iata: "IGU" },
			{ iata: "BHZ" }
		];

		const buscaPassagensBestPriceContent = document.querySelector(".bestprices-box .row");
		const buscaPassagensDestinyContent = document.querySelector(".destination-box .swiper-wrapper");

		const destinationInternationalItems = document.querySelectorAll(
			"#swiper-destination-international .card-largetitle"
		);

		if (destinationInternationalItems.length) {
			[].forEach.call(destinationInternationalItems, function(item, index) {
				const airport = item.classList[1];
				let parameterToApi = "to";

				if (airport.length == 2) {
					parameterToApi = "to_country";
				}

				nanoajax.ajax(
					{
						url: `${urlBuscaPassagens}best-prices/flights?size=1&exclusivo_maxmilhas=false&${parameterToApi}=${airport}`,
						method: "GET"
					},
					function(code, responseText) {
						if (code === 200 && responseText && JSON.parse(responseText).length) {
							const data = JSON.parse(responseText);
							const price = formatCurrency(data[0].best_price_mm_w_taxes);

							if (price) {
								document.querySelector(`.card-largetitle.${airport} h5`).innerHTML = price;
							}
						}
					}
				);
			});

			const destinationInternational = () => {
				const destinationInternationalsParent = document.querySelector(
					"#swiper-destination-international"
				).parentElement.parentElement;

				destinationInternationalsParent.classList.remove("hide");

				const swiperDestinationInternational = new Swiper(
					"#swiper-destination-international .swiper-container",
					{
						pagination: { 
							el: "#swiper-destination-international .swiper-pagination",
							clickable: true,
						},
						simulateTouch: false,
						slidesPerView: 3,
						slidesPerGroup: 3,
						slidesPerColumn: 1,
						spaceBetween: 30,
						navigation: {
							nextEl: "#swiper-destination-international .swiper-button-next",
							prevEl: "#swiper-destination-international .swiper-button-prev",
						},
						breakpoints: {
							768: {
								simulateTouch: true,
								slidesPerView: 1,
								slidesPerGroup: 1,
								slidesPerColumn: 1
							}
						}
					}
				);
			};

			window.destinationInternational = destinationInternational;
		}

		const searchBestPrices = airportsArray => {
			const fetchOrigin = state.fetchingResourceFrom;
			const airports = Array.isArray(airportsArray)
				? airportsArray
				: aeroportosmaisbuscados.map(airport => airport.iata);
			const limitBuscaPassagensMelhoresPrecos = 30;

			buscaPassagensBestPriceContent.innerHTML = "";

			const mountCards = data => {
				let html = "";
				data.map((item, index) => {
					let priceAirline = 0;
					let priceMM = 0;
					let price = 0;

					if (item.best_price_airline_w_taxes && item.best_price_mm_w_taxes) {
						priceAirline = formatCurrency(item.best_price_airline_w_taxes);
						priceMM = formatCurrency(item.best_price_mm_w_taxes);
						price = formatCurrency(item.best_price_mm_w_taxes);
					}

					const nameOrigin = item.origin ? item.origin : item.origin_code.toUpperCase();
					const nameDestination = item.destination
						? item.destination
						: item.destination_code.toUpperCase();

					const rawPriceAirline = item.best_price_airline_w_taxes;
					const rawPriceMM = item.best_price_mm_w_taxes;

					const percentage = parseInt((rawPriceAirline - rawPriceMM) / rawPriceAirline * 100);
					const classPercentage = percentage <= 0 ? "hide" : "";

					html += `<div class="col-md-8 col-xs-16">
					<a target="_blank" rel="nofollow" href="${item.url}">
						<div class="bestprices-item">
							<h4 class="bestprices-item--title">Passagens aéreas de
								<span><span class="origin">${nameOrigin} (${
						item.origin_code
					})</span> <i class="icon-arrow-right"></i>
								<span class="bestprices-item--title-separator visible-sm visible-xs">Para</span> ${nameDestination} (${
						item.destination_code
					})</span></h4>
							<div class="bestprices-item--price">
								${
									isNaN(percentage)
										? ``
										: `<span class="${classPercentage}">Economize <span>${percentage}%</span></span>`
								}
								<h5>${price ? `${price}` : "Pesquisar"}</h5>
							</div>
						</div>
					</a>
				</div>`;
				});

				if (fetchOrigin == state.fetchingResourceFrom)
					buscaPassagensBestPriceContent.innerHTML = html;
			};

			airports.map((aeroporto, i) => {
				geoLocatedAirports.push(
					new Promise((resolve, reject) => {
						nanoajax.ajax(
							{
								url: `${urlBuscaPassagens}best-prices/flights?from=${aeroporto}&size=${limitBuscaPassagensMelhoresPrecos}&exclusivo_maxmilhas=false`,
								method: "GET"
							},
							function(code, responseText, request) {
								let data;

								if (code === 200 && responseText && JSON.parse(responseText).length > 0) {
									data = JSON.parse(responseText);
									data.forEach(function(e, index) {
										data[index]["url"] = data[index]["url"].replace(
											"https://www.maxmilhas.com.br",
											""
										);
									});

									resolve(data);
								} else {
									console.log(`aeroporto não reconhecido (${aeroporto}) - ${responseText}`);
									resolve([]);
									return airportsArray;
								}
							}
						);
					})
				);
			});

			Promise.all(geoLocatedAirports).then(allData => {
				const data = allData.reduce((data, arr) => data.concat(arr), []);
				if (data && data.length > 3) mountCards(data);
				else {
					try {
						nanoajax.ajax(
							{
								url: `${urlBuscaPassagens}/best-prices/flights?size=12&exclusivo_maxmilhas=false`,
								method: "GET"
							},
							function(code, responseText) {
								let data;

								if (code === 200 && responseText && JSON.parse(responseText).length > 3) {
									data = JSON.parse(responseText);
									mountCards(data);

									data.forEach(function(e, index) {
										data[index]["url"] = data[index]["url"].replace(
											"https://www.maxmilhas.com.br",
											""
										);
									});
								} else mountCards(fallbackBestPrices());
							}
						);
					} catch (err) {
						console.error(err);
						mountCards(fallbackBestPrices());
					}
				}

				const node = document.querySelector(".bestprices-box .loading");
				if (node) node.style.display = "none";
			});

			return airportsArray;
		};

		function getLocation() {
			return new Promise(function(resolve, reject) {
				navigator.geolocation.getCurrentPosition(
					function(position) {
						if (position && position.coords) {
							resolve(position.coords);
						} else {
							reject({ fallbackAirports: aeroportosmaisbuscados });
						}
					},
					function(error) {
						reject({ fallbackAirports: aeroportosmaisbuscados });
					}
				);
			});
		}

		const getGeoLocationFromAPI = airportData => {
			return new Promise((resolve, reject) => {
				if (airportData && Array.isArray(airportData.airports)) {
					return airportData.airports;
				}

				nanoajax.ajax({ url: `${NEARBY_PLACES_API}/airports?max=1`, timeout: 5000, method: "GET" }, function(
					code,
					responseText
				) {
					if (code === 200) {
						try {
							const airports = resolve(JSON.parse(responseText));
							if (Array.isArray(airports)) {
								return airports;
							} else {
								resolve({ fallbackAirports: aeroportosmaisbuscados });
							}
						} catch (e) {
							resolve({ fallbackAirports: aeroportosmaisbuscados });
						}
					} else {
						resolve({ fallbackAirports: aeroportosmaisbuscados });
					}
				});
			});
		};

		const initTrends = airportsArray => {
			airportsArray = Array.isArray(airportsArray)
				? airportsArray
				: aeroportosmaisbuscados.map(airport => {
						const airportIata = airport.group ? airport.group : airport.iata;
						return airportIata;
				  });
			const trendsBox = document.getElementById("trends-box");
			if (trendsBox) {
				new Trends(trendsBox, airportsArray, { size: 12 });
			}
			return airportsArray;
		};

		/**
		 * Decora o trecho de ida com os dados obtidos por geolocalização
		 * se possuir uma iata agrupadora, prioriza essa iata
		 * senão, preenche com o primeira info de aeroporto que vier
		 * @param {Array} airportsArray array de aeroportos
		 * @returns {Array} array de objetos de aeroportos
		 * @todo Implementar atributo country no retorno da chamada de geolocalização
		 */
		const informAirport = airportData => {
			if (Array.isArray(airportData)) {
				const groupIATA = airportData.filter(airport => airport.group);
				const searchFormElement = document.getElementById("search-form-section");

				if (searchFormElement) {
					if (groupIATA.length > 0) {
						stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
							city: groupIATA[0].city,
							iata: groupIATA[0].group,
							name: "Todos",
							country: groupIATA[0].country == "Brazil" ? "BR" : "" //TODO - retornar países com abreviação de dois caracteres do banco
						});
					} else {
						stretchFrom.decorateField(document.querySelector(`#${stretchFrom.elm.id}`), {
							city: airportData[0].city,
							iata: airportData[0].iata,
							name: airportData[0].name,
							country: airportData[0].country == "Brazil" ? "BR" : ""
						});
					}
				}

				// VERIFICO SE EXISTE EXISTE MAIS DE UM E TRANSFORMO NO GRUPO
				const airportsGroup = [];

				airportData.map((airport, i) => {
					if (airport["group"]) {
						airportData[i]["iata"] = airport["group"];
					}

					if (airport["group"] && airportsGroup.includes(airport["group"])) {
						airportData.splice(0, i);
						return true;
					}

					if (airport["group"]) {
						airportsGroup.push(airport["group"]);
					}
				});

				return airportData.map(airport => airport.iata);
			} else {
				return airportData.fallbackAirports.map(airport => airport.iata);
			}
		};

		getGeoLocationFromAPI({ airports: aeroportosmaisbuscados })
			.then(airports => {
				state.fetchingResourceFrom = "FALLBACK";
				return airports.map(airport => {
					const airportIata = airport.group ? airport.group : airport.iata;
					return airportIata;
				});
			})
			.then(initTrends)
			.then(searchBestPrices)
			.then(() => {
				[].slice
					.call(document.querySelectorAll(".loading"))
					.forEach(elm => (elm.style.display = "none"));
			})
			.catch(err => {
				console.log(err);
			});

		getGeoLocationFromAPI()
			.then(airports => {
				state.fetchingResourceFrom = "GEO";
				return airports;
			})
			.then(informAirport)
			.then(initTrends)
			.then(airports => {
				document.querySelector(".bestprices-box .row").innerHTML = "";
				return airports;
			})
			.then(searchBestPrices)
			.then(() => {
				[].slice
					.call(document.querySelectorAll(".loading"))
					.forEach(elm => (elm.style.display = "none"));
			})
			.catch(err => console.log(err));
	}
};